export enum InstructorAccountType {
    OFFICIAL_ACCOUNTS = "premium",
    TRIAL_PERIOD = "trial",
    UNVERIFIED = "unverified",
    DECLINED = "declined",
}
